import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardRoute } from '../../auth/guard.ts'
import { NAV_PATHS } from '../../navigation/paths.ts'
import { rootRoute } from '../root.tsx'

// The club's staff. The filter is a typed search param and not local state, so a filtered
// list is a link somebody can send.

export const PEOPLE_FILTERS = ['all', 'admin', 'coach'] as const

export type PeopleFilter = (typeof PEOPLE_FILTERS)[number]

export interface PeopleSearch {
  readonly filter: PeopleFilter
}

/** An invented value in the URL becomes `all` rather than reaching a label. */
export function parsePeopleFilter(value: unknown): PeopleFilter {
  if (typeof value !== 'string') return 'all'
  return PEOPLE_FILTERS.includes(value as PeopleFilter) ? (value as PeopleFilter) : 'all'
}

export const officialPeopleRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: NAV_PATHS.officialPeople,
  validateSearch: (search: Record<string, unknown>): PeopleSearch => ({
    filter: parsePeopleFilter(search.filter),
  }),
  beforeLoad: ({ context, location }) =>
    guardRoute({
      queryClient: context.queryClient,
      requiredRoles: ['club'],
      currentPath: location.href,
    }),
  staticData: { opensOnHero: true },
  component: lazyRouteComponent(() => import('../../pages/official/people.tsx')),
})

/** The link other pages take the path from, instead of respelling it. */
export const officialPeopleLink = {
  to: NAV_PATHS.officialPeople,
  search: { filter: 'all' },
} as const
